// Badge.tsx
import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { Badge as MuiBadge } from '@mui/material';
import Colors from '../global/Colors';
import Fonts from '../global/Fonts';

const StyledBadge = styled(({ className, $colorMode, ...props }: { className?: string; $colorMode: 'light' | 'dark' | 'neutral' } & any) => (
  <MuiBadge {...props} className={className} />
))<{ $colorMode: 'light' | 'dark' | 'neutral' }>`
  &.MuiBadge-root .MuiBadge-badge {
    background-color: ${({ $colorMode }) => ($colorMode === 'light' ? Colors.grey9 : $colorMode === 'dark' ? Colors.white : Colors.grey5)};
    color: ${({ $colorMode }) => ($colorMode === 'light' ? Colors.white : $colorMode === 'dark' ? Colors.grey9 : Colors.white)};
    font-family: ${Fonts.lexendMedium.fontFamily};
    font-weight: ${Fonts.lexendMedium.fontWeight};
    font-size: 10px;
    line-height: 1.2em;
    height: auto;
    min-width: 14px;
    padding: 1px 4px;
    border-radius: 10px;
  }
`;

interface BadgeProps {
  children: ReactNode;
  content: ReactNode;
  colorMode?: 'light' | 'dark' | 'neutral';
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'right';
  invisible?: boolean;
  max?: number;
  showZero?: boolean;
}

const Badge: FunctionComponent<BadgeProps> = ({
  children,
  content,
  colorMode = 'neutral',
  vertical = 'top',
  horizontal = 'right',
  invisible = false,
  max = 99,
  showZero = false,
}) => {
  return (
    <StyledBadge
      badgeContent={content}
      $colorMode={colorMode}
      anchorOrigin={{
        vertical,
        horizontal,
      }}
      invisible={invisible}
      max={max}
      showZero={showZero}
    >
      {children}
    </StyledBadge>
  );
};

export default Badge;